/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Modal context
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { createContext, useContext } from 'react';

import { EModalStatus } from '../types/modalTypes';

export interface IModalContext {
    status: EModalStatus;
}

export const useModalContext = () => {
    const context = useContext<IModalContext>(ModalContext);
    if (!context) {
        throw new Error(
            'Modal compound components cannot be rendered outside the Modal component',
        );
    }

    return context;
};

const ModalContext = createContext<IModalContext>({
    status: EModalStatus.start,
});

export default ModalContext;
